import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import ExtendedSnackbar from '../../../../components/ExtendedSnackbar/ExtendedSnackbar';
import messages from './messagesReservations';
import './reservations.css';
import SeatPreferences from './SeatPreferences';
import BikeReservation from './BikeReservation';

const ReservationsView = ({
	faresSelected,
	bikeReservations,
	seatReservation,
	shoppingPassengers,
	onChangeReservation,
	onChangeAllSegmentReservation,
	onChangeAllLegReservation,
	onChangePassengerReservation,
	onChangeBikeReservation,
	selectedSeatReservations,
	selectedBikeReservations,
	intl,
	exchangeOrderMode,
	seatMapData,
}) => {
	const { formatMessage } = intl;
	const lblLeg = formatMessage(messages.lblLeg);
	const lblTo = formatMessage(messages.lblTo);
	const [data, setData] = useState({ alertText: '', isProcessing: false });

	const handleSnackbarClose = () => {
		setData({ ...data, alertText: '' });
	};

	const paxIds = shoppingPassengers
		.toJS()
		?.map((p) => p.ShoppingPassengerRefId);

	return (
		<div className="container-fluid" styleName="dialogContent">
			{faresSelected.toJS().map((item, index) => (
				<div
					key={item.legId}
					className="row"
					styleName="legContent"
					data-test="faresSelected"
				>
					<div className="col-12">
						<div className="row" styleName="segment legSegment">
							<div className="col-4" styleName="legSegmentLeft">
								{`${lblLeg} ${index + 1}: ${item.leg.ShoppingLegOrigStationName} ${lblTo} ${item.leg.ShoppingLegDestStationName}`}
							</div>
						</div>
						{seatReservation && (
							<SeatPreferences
								validatedSeatMapData={seatMapData}
								travelSegments={
									item.leg.ShoppingLegSolutions[0].ShoppingFareTravelSegments
								}
								shoppingContext={
									item.leg.ShoppingLegSolutions[0].ShoppingContext
								}
								seatPreferences={item.fare.seatPreferences}
								optionalPrices={item.fare.optionalPrices}
								fareCodes={item.fare.fareCodes}
								paxIds={paxIds}
								onChangeReservation={onChangeReservation}
								onChangeAllSegmentReservation={onChangeAllSegmentReservation}
								onChangeAllLegReservation={onChangeAllLegReservation}
								onChangePassengerReservation={onChangePassengerReservation}
								selectedSeatReservations={selectedSeatReservations}
								exchangeOrderMode={exchangeOrderMode}
							/>
						)}

						{!seatReservation && bikeReservations && (
							<>
								{paxIds.map((p) => (
									<BikeReservation
										key={p}
										travelSegments={
											item.leg.ShoppingLegSolutions[0]
												.ShoppingFareTravelSegments
										}
										bikeReservations={bikeReservations.toJS()}
										passengerId={p}
										onChangeBikeReservation={onChangeBikeReservation}
										selectedBikeReservations={selectedBikeReservations}
									/>
								))}
							</>
						)}
					</div>
				</div>
			))}
			<ExtendedSnackbar
				id="srtReservationsSnackBar"
				open={data?.alertText !== ''}
				message={data?.alertText}
				onClose={handleSnackbarClose}
			/>
		</div>
	);
};

ReservationsView.propTypes = {
	intl: PropTypes.object,
	faresSelected: PropTypes.object.isRequired,
	bikeReservations: PropTypes.object,
	seatReservation: PropTypes.bool,
	shoppingPassengers: PropTypes.object.isRequired,
	selectedSeatReservations: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object,
	]),
	selectedBikeReservations: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object,
	]),
	onChangeReservation: PropTypes.func,
	onChangeAllSegmentReservation: PropTypes.func,
	onChangeAllLegReservation: PropTypes.func,
	onChangePassengerReservation: PropTypes.func,
	onChangeBikeReservation: PropTypes.func,
	exchangeOrderMode: PropTypes.bool,
	seatMapData: PropTypes.array,
};

ReservationsView.defautProps = {
	selectedSeatReservations: null,
	selectedBikeReservations: null,
	bikeReservations: [],
	seatReservation: true,
	exchangeOrderMode: false,
};

export { ReservationsView as ReservationsViewAlias };

export default injectIntl(ReservationsView);
